<template>
	<div class="learner_dashboard learner_profile" aria-label="Advisee Profile Page">

		<div class="row pg_sec_head">
			<div class="col-10">
				<div class="hd_txt">{{userName}}</div>
			</div>
		</div>

		<div class="row pg_sec_content">
			<div class="col-12">
				<div class="row">
					<div class="col-2">
						<div class="row fld_row">
							<div class="thumbnail">
                <div class="person_thumbnail">
                  <div class="thumbnail_container">
                    <div class="default">
                      <div class="thumbnail">
                        <div class="ic thumbnail_icon icon-mentor" style="color: #787878;"></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
						</div>
					</div>
					<div class="col-10">
						<div class="row fld_row">
							<div class="col-11 fld_label">
                <span class="block_label" tabindex="0">Program Interest : </span>
                <span class="block_val" v-if="advisee.adviseeSharedStreams && advisee.adviseeSharedStreams.length > 0 && advisee.adviseeSharedStreams[0].majorTitle && advisee.adviseeSharedStreams[0].majorTitle.length > 0">{{advisee.adviseeSharedStreams[0].majorTitle}}</span>
                <span class="block_val" v-else>Undecided</span>
              </div>
						</div>
						<div class="row fld_row">
							<div class="col-11 fld_label">
                <span class="block_label" tabindex="0">Career Interest : </span>
                <span class="block_val" v-if="advisee.careerGoal">{{advisee.careerGoal}}</span>
                <span class="block_val" v-else>Undecided</span>
              </div>
						</div>
						<div class="row fld_row">
							<div class="col-11 fld_label">
								Personal Info : {{email}}
							</div>
						</div>
					</div>

				</div>
			</div>
		</div>

		<learner-profile-resume ref="learnerProfileResume" :uuid="uuid"></learner-profile-resume>

		<!-- Profile questions and answers -->
		<div class="row pg_sec_head">
			<div class="col-10">
				<div class="hd_txt">Program & Career Interest</div>
			</div>
		</div>

		<div class="row pg_sec_content">
			<div class="col-12">
				<div class="row fld_row" v-for="(question, i) in questions">
					<div class="ic_container col-2">
						<div class="ic" :class="'ic-' + question.icon"></div>
					</div>
					<div class="col-10">
						<div class="row">
							<div class="col-6 fld_label">
								<div>{{question.shortTitle}}</div>
							</div>
							<template v-if="question.type === 'SELECT'">
								<template v-if="question.optionType === 'DYNAMIC'">
									<div class="col-6 fld_val">
										<div class="selected_entity" v-if="question.response">
											<span :title="question.response">{{question.response}}</span>
										</div>
										<div class="no_info" v-else>
											N/A
										</div>
									</div>
								</template>
								<template v-if="question.optionType === 'STATIC'">
									<div class="col-6 fld_val">
										<div class="selected_entity" v-if="question.response">
												<span :title="question.response">{{question.response}}</span>
										</div>
										<div class="no_info" v-else>
											N/A
										</div>
									</div>
								</template>
                <template v-if="question.optionType === 'STATIC-MULTI'">
									<div class="col-6 fld_val">
										<div v-if="question.selectedResponses && question.selectedResponses.length > 0">
											<div class="selected_entity" v-for="sR in question.selectedResponses" v-if="sR">
												<span :title="sR">{{sR}}</span>
											</div>
										</div>
										<div class="no_info" v-else>
											N/A
										</div>
									</div>
								</template>
                <template v-if="question.optionType === 'DYNAMIC-MULTI'">
									<div class="col-6 fld_val">
										<div v-if="question.selectedResponses && question.selectedResponses.length > 0">
											<div class="selected_entity" v-for="sR in question.selectedResponses">
												<span :title="sR">{{sR}}</span>
											</div>
										</div>
										<div class="no_info" v-else>
											N/A
										</div>
									</div>
								</template>
							</template>
							<template v-else-if="question.type === 'MULTI_LINE_TEXT'">
								<div class="col-6 fld_val">
									<textarea :rows="question.lineCount" cols="50" :maxlength="question.responseLimit" v-model.trim="question.response" :disabled="true"></textarea>
								</div>
							</template>
						</div>
					</div>
				</div>
			</div>
		</div>

	</div>
</template>

<script>
	import _ from 'lodash'
	import { mapActions } from 'vuex'
	import LearnerProfileResume from '../../dashboard/components/LearnerProfileResume'

	export default {
		name: 'advisor-learner-profile-page',
		props: ['uuid'],
		components: {
			LearnerProfileResume
    },
		data: () => {
			return {
				advisee: {},
				questions: []
			}
		},
		computed: {
			email () {
        return this.advisee.userEmail
      },
			userName () {
        return this.advisee.userName
      }
		},
		async created () {
			this.advisee = await this.loadAdviseeDetail(this.uuid)
		},
		mounted () {
			this.$parent.$refs.loadingModal.show()
			this.populateLearnerProfileQuestionData()
    },
		methods: {
			...mapActions([
				'loadMajorMinor',
        'loadCareerByCode',
				'loadAdviseeDetail',
				'loadQuestionsForGroupAndUser'
	    ]),
	    populateLearnerProfileQuestionData () {
	    	this.questions = []
        this.loadQuestionsForGroupAndUser({group: 'PROFILE_POPUP_1', userId: this.uuid}).then(questions => {
	        _.forEach(questions, (question, index) => {
	        	let response = (question.responses && question.responses.length > 0) ? question.responses[0] : null
	        	if ((question.type === 'SELECT') || (question.type === 'MULTI_LINE_TEXT')) {
            	if ((question.optionSource === 'CAREER') || (question.optionSource === 'PROGRAM')) {
            		question.response = ''
            	} else {
            		question.response = response
            	}
            }
            if (question.optionType === 'STATIC') {
          		if (question.response === 'Other') {
                question.response = question.responses[1]
              }
            }
            if (question.optionType === 'DYNAMIC') {
              if (question.optionSource === 'CAREER') {
              	this.loadCareerByCode(response).then(career => {
              		question.response = career.name
              	})
              } else if (question.optionSource === 'PROGRAM') {
              	this.loadMajorMinor({code: response}).then(program => {
              		question.response = program.name
              	})
              }
            }
            if (question.optionType === 'DYNAMIC-MULTI') {
              if (question.optionSource === 'CAREER') {
                question.selectedResponses = []
                if (question.responses) {
                  question.responses.forEach((item, i) => {
                    this.loadCareerByCode(item).then(career => {
                  		question.selectedResponses.push(career.name)
                  	})
                  })
                }
              } else if (question.optionSource === 'PROGRAM') {
                question.selectedResponses = []
                if (question.responses) {
                  question.responses.forEach((item, i) => {
                    this.loadMajorMinor({code: item}).then(program => {
                  		question.selectedResponses.push(program.name)
                  	})
                  })
                }
              }
            }
            if (question.optionType === 'STATIC-MULTI') {
              question.selectedResponses = []
              if (question.responses) {
                question.responses.forEach((item, i) => {
                	question.selectedResponses.push(item)
                })
              }
            }
            this.questions.push(question)
        	})
        	setTimeout(() => {
        		this.$parent.$refs.loadingModal.hide()
        	}, 1000)
	      })
      }
	  }
	}
</script>



// WEBPACK FOOTER //
// src/app/adviseeTracker/components/AdvisorLearnerProfilePage.vue